import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AdminAuthContext = createContext();
const API = '/api';

export const useAdminAuth = () => {
  return useContext(AdminAuthContext);
};

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [adminToken, setAdminToken] = useState(localStorage.getItem('adminToken'));
  const [isLoading, setIsLoading] = useState(Boolean(localStorage.getItem('adminToken')));
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdmin = async () => {
      if (adminToken) {
        try {
          const response = await axios.get(`${API}/admins/me`, {
            headers: {
              Authorization: `Bearer ${adminToken}`,
            },
          });

          setAdmin(response.data);
        } catch (error) {
          console.error('Error fetching admin details:', error);
          localStorage.removeItem('adminToken');
          setAdminToken(null);
          setAdmin(null);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchAdmin();
  }, [adminToken]);

  const adminLogin = async (token) => {
    localStorage.setItem('adminToken', token);
    setAdminToken(token);
    setIsLoading(true);

    try {
      const response = await axios.get(`${API}/admins/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setAdmin(response.data);
    } catch (error) {
      console.error('Error fetching admin details after login:', error);
      localStorage.removeItem('adminToken');
      setAdminToken(null);
      setAdmin(null);
    } finally {
      setIsLoading(false);
    }
  };

  const adminLogout = () => {
    localStorage.removeItem('adminToken');
    setAdminToken(null);
    setAdmin(null);
    setIsLoading(false);
    navigate('/');
  };

  const value = {
    admin,
    adminToken,
    adminLogin,
    adminLogout,
    isLoading,
    isAuthenticated: !!admin,
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};
